/**
 * Single source of truth for mobile bottom-navigation dimensions.
 *
 * Used by:
 *  - `MobileBottomNav` (renders the bar)
 *  - `index.css` rule that reserves `padding-bottom` on <body> so feed
 *    content never sits under the fixed nav
 *  - `ScrollToTopPill` and any floating UI that must sit ABOVE the bar
 *
 * Keep these values in lock-step.  If you change `NAV_HEIGHT_PX`, also
 * update `--zen-nav-height` in `src/index.css`.
 */

/** Visible navigation bar height (excludes the iOS home-indicator safe area). */
export const NAV_HEIGHT_PX = 62;

/** CSS expression for the home-indicator inset.  Safari + Capacitor WKWebView. */
export const BOTTOM_SAFE_AREA = 'env(safe-area-inset-bottom, 0px)';

/** Combined inset to clear the bar (nav height + safe area). */
export const BOTTOM_NAV_OFFSET = `calc(${NAV_HEIGHT_PX}px + ${BOTTOM_SAFE_AREA})`;
